import EmployeeRepository from '@api/repositories/employee-repository'
import { DATE_FORMAT } from '@app/constants/date'
import {
  IEmployee,
  IOrganizationEmployee,
} from '@app/interfaces/employee/employee'
import ModalFooter from '@app/shared/modal-footer/modal-footer'
import { openNotificationWithIcon } from '@app/shared/notification/notification'
import {
  refreshEmployee,
  updateEmployee,
} from '@app/store/actions/employee-actions'
import { Button, DatePicker, Form, Input, Modal, Spin } from 'antd'
import locale from 'antd/es/date-picker/locale/ru_RU'
import { AxiosResponse } from 'axios'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'

interface props {
  employee: IOrganizationEmployee
}

const EmployeeSickListForm: React.FC<props> = ({ employee }) => {
  const [confirmLoading, setConfirmLoading] = useState<boolean>(false)
  const [form] = Form.useForm()
  const [t, i18n] = useTranslation()
  const dispatch = useDispatch()
  const [visible, setVisible] = useState<boolean>(false)
  const showModal = () => setVisible(true)
  const hideModal = () => {
    setVisible(false)
    form.resetFields()
  }
  const onFinish = async (values: any) => {
    const newValues = {
      ...values,
      employeePositionId: employee.id ? employee.id : undefined,
      startDate: values['startDate'].format(DATE_FORMAT),
      endDate: values['endDate'].format(DATE_FORMAT),
    }

    setConfirmLoading(true)

    EmployeeRepository.sickLeave(newValues)
      .then((response: AxiosResponse<IEmployee>) => {
        if (response.status === 201) {
          dispatch(updateEmployee(response.data))
          dispatch(refreshEmployee())
          openNotificationWithIcon('success', t('employee.sickListSet'))
          setConfirmLoading(false)
          hideModal()
        }
      })
      .catch(() => {
        openNotificationWithIcon('error', t('employee.sickListError'))
        setConfirmLoading(false)
      })
  }
  return (
    <React.Fragment>
      <Button onClick={showModal} type={'link'}>
        {t('employee.sickList')}
      </Button>

      <Modal
        open={visible}
        title={t('employee.sickList')}
        onCancel={hideModal}
        footer={[
          <React.Fragment key={1}>
            <ModalFooter
              confirm={confirmLoading}
              onCancel={hideModal}
              onSubmit={form.submit}
            />
          </React.Fragment>,
        ]}
      >
        <Spin spinning={confirmLoading}>
          <Form
            form={form}
            onFinish={onFinish}
            initialValues={{ employeeId: employee.employee?.id }}
            layout={'vertical'}
          >
            <Form.Item hidden={true} name={'employeeId'}>
              <Input />
            </Form.Item>
            <Form.Item
              label={t('pupils.orderNo')}
              name={'orderNo'}
              rules={[
                {
                  transform: (value) =>
                    typeof value === 'string' ? value.trim() : undefined,
                  required: true,
                  message: t('errors.requiredMessage'),
                },
              ]}
            >
              <Input disabled={confirmLoading} />
            </Form.Item>
            <Form.Item
              rules={[
                {
                  required: true,
                  message: t('errors.requiredMessage'),
                },
              ]}
              name={'startDate'}
              label={t('employee.sickListStart')}
            >
              <DatePicker style={{ width: '100%' }} locale={locale} />
            </Form.Item>
            <Form.Item
              rules={[
                {
                  required: true,
                  message: t('errors.requiredMessage'),
                },
              ]}
              name={'endDate'}
              label={t('employee.sickListEnd')}
            >
              <DatePicker style={{ width: '100%' }} locale={locale} />
            </Form.Item>
          </Form>
        </Spin>
      </Modal>
    </React.Fragment>
  )
}

export default EmployeeSickListForm
